import React from "react";
import 'bootstrap-icons/font/bootstrap-icons.css'; 

export default function WhyChooseUs() {
  const features = [
    {
      icon: "bi-lightning-charge-fill",
      title: "Agile & Scalable Development",
    },
    {
      icon: "bi-bar-chart-line-fill",
      title: "SEO & Conversion-Optimized Products",
    },
    {
      icon: "bi-box-arrow-up-right",
      title: "Full Lifecycle Support",
    },
    {
      icon: "bi-currency-rupee",
      title: "Transparent & Competitive Pricing",
    },
    {
      icon: "bi-award-fill",
      title: "Certified & Experienced Team",
    },
    {
      icon: "bi-tools",
      title: "Post-Launch Support & Maintenance",
    },
  ];

  return (
    <div className="bg-light text-center py-5">
      <div className="container">
        <h3 className="mb-4">Why Choose <span className="text-primary">Vizionexl</span>?</h3>
        <p className="text-muted mb-5">
          We deliver <strong>quality, innovation, and scalable technology solutions</strong> to meet your business goals.
        </p>

        <div className="row">
          {features.map((item, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0">
                <div className="card-body">
                  <i className={`bi ${item.icon} text-primary mb-3`} style={{ fontSize: "2rem" }}></i>
                  <h6>{item.title}</h6>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
